import { reduceFields, validator } from '@shopify/react-form';
import { format, subDays, subYears } from 'date-fns';
import {
  VALID_DATE,
  VALID_PHONE_WITH_OPTIONAL_CHARACTERS,
  VALID_ZIPCODE,
} from './const';

const fiveYearsAgoDate = subYears(new Date(), 5);

const yesterdayDate = subDays(new Date(), 1);

const formatYearMonthDate = (inputDate: Date) =>
  format(inputDate, 'yyyy-MM-dd');

export const isAValidHealowNameCallback = input =>
  /^[a-zA-Z][a-zA-Z().',-\s]+$/.test(input) && /[a-zA-Z]$/.test(input);

// Regex validation: must start with alphabet, etc. per Healow's specification and can't end with special character
export const isAValidHealowName = validator(isAValidHealowNameCallback);

export const INVALID_HEALOW_NAME_MESSAGE =
  "Name must start and end with a letter and contain no special characters other than ( ) . ' , - and space.";

export const isAZipCode = validator(input => VALID_ZIPCODE.test(input));

export const maxBirthDateString = `${formatYearMonthDate(fiveYearsAgoDate)}`;

export const yesterdayBirthDateString = `${formatYearMonthDate(yesterdayDate)}`;

export const isAtLeastFiveYearsOld = validator(input => {
  const isValidBirthdayFormat = VALID_DATE.test(input);
  if (!isValidBirthdayFormat) return isValidBirthdayFormat;
  return input <= maxBirthDateString;
});

export const isAtLeastADayOld = validator(input => {
  const isValidBirthdayFormat = VALID_DATE.test(input);
  if (!isValidBirthdayFormat) return isValidBirthdayFormat;
  return input <= yesterdayBirthDateString;
});

export const isValidBirthdayFormat = validator(input => VALID_DATE.test(input));

export const isAPhoneNumber = validator(input =>
  VALID_PHONE_WITH_OPTIONAL_CHARACTERS.test(input)
);

export const isFileTypeSupported = (
  fileType: string,
  fileName?: string
): boolean => {
  const SUPPORTED_FILE_TYPES = [
    'image/jpeg',
    'image/bmp',
    'image/heic',
    'image/heif',
    'image/tiff',
    'image/svg+xml',
    'image/png',
    'text/plain',
    'application/pdf',
    'image/x-windows-bmp',
    'image/x-ms-bmp',
    'application/octet-stream',
  ];
  return (
    SUPPORTED_FILE_TYPES.includes(fileType) ||
    (fileName && fileName.toLowerCase().endsWith('.heic'))
  );
};

export const allDirty = (fieldsToCheck, optionalFields) =>
  reduceFields(
    fieldsToCheck,
    (previousDirty, { value, allErrors }, path) =>
      previousDirty &&
      ((!!value && allErrors.length === 0) ||
        optionalFields.includes(path[0] as string)),
    true
  );
